import React, { useRef, useState } from "react";
import { Megaphone, Tag, AlertTriangle, Play, Pause } from "lucide-react";

// Phase 2.5.3b — "From businesses you follow": announcements & offers delivered to a follower.
// Tap-to-play uses a private inline <audio> element — it NEVER touches the main radio player or
// playlist engine, so nothing here can interrupt or break normal playback.
export default function FollowFeed({ feed = [] }) {
  const [playingId, setPlayingId] = useState(null);
  const audioRef = useRef(null);
  if (!feed || feed.length === 0) return null;

  const toggle = (item) => {
    const el = audioRef.current;
    if (!el || !item.audio_url) return;
    if (playingId === item.id) { el.pause(); setPlayingId(null); return; }
    el.src = item.audio_url;
    el.play().then(() => setPlayingId(item.id)).catch(() => setPlayingId(null));
  };

  const meta = (item) =>
    item.is_emergency ? { Icon: AlertTriangle, label: "Alert", cls: "text-red-400 bg-red-400/10" }
    : item.is_offer   ? { Icon: Tag,           label: "Offer", cls: "text-emerald-400 bg-emerald-400/10" }
    :                    { Icon: Megaphone,     label: "News",  cls: "text-white/50 bg-white/[0.06]" };

  return (
    <>
      <audio ref={audioRef} onEnded={() => setPlayingId(null)} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {feed.map((item) => {
          const { Icon, label, cls } = meta(item);
          const isPlaying = playingId === item.id;
          return (
            <div key={item.id} className="bg-white/[0.03] rounded-2xl p-4 border border-white/[0.06] flex items-center gap-3">
              <button onClick={() => toggle(item)} disabled={!item.audio_url}
                className="w-10 h-10 rounded-full bg-white text-black flex items-center justify-center flex-shrink-0 hover:bg-white/90 transition disabled:opacity-40">
                {isPlaying ? <Pause size={16} /> : <Play size={16} />}
              </button>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="font-semibold text-sm truncate">{item.business_name}</span>
                  <span className={`text-[9px] px-1.5 py-0.5 rounded font-semibold uppercase tracking-wider flex items-center gap-1 flex-shrink-0 ${cls}`}>
                    <Icon size={10} strokeWidth={2} />{label}
                  </span>
                </div>
                <p className="text-white/50 text-sm truncate">{item.title}</p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
